import React, {useReducer} from "react";

const reducerFactory = () => {
    const reducer = (state, action) => {
        const {type, payload, isAppend} = action;

        if (type === "REPLACE_STATE") {
            return {...payload};
        }

        if (Array.isArray(state[type]) && typeof isAppend === "boolean") {
            const selectedData = [...state[type]];
            if (isAppend) {
                selectedData.push(payload);
            } else {
                selectedData.splice(selectedData.indexOf(payload), 1);
            }
            const resultedState = {
                ...state,
                [type]: selectedData
            };
            return resultedState;
        }
        const resultedState = {
            ...state,
            [type]: payload
        };
        return resultedState;
    };

    return reducer;
};

export const useForm = initialValues => {
    const reducer = reducerFactory();
    const [state, dispatch] = useReducer(reducer, initialValues);
    return [state, dispatch];
};
